<template>
    <div>
        <h2>Important – Please read and acknowledge</h2>

        <div class="terms">
            
                <b>Visa Requirements</b>
                <p>Citizens of Singapore, Brunei and Japan holding ordinary passports may enter China without a visa through the ports of entry open to foreigners provided that they come to China for tourism, family visit, business or transit, and intend to stay in China for no more than 15 days.</p>
                
                <p>All other nationalities will require a visa to enter China, <u>please get in touch with your local HR business partner for information on visa application.</u></p>

                <p>Please note that registration via this portal is <u>subjected to approval</u>. Once details of your flight/hotel is confirmed, we will email your flight and hotel itineraries to you.</p>

                <p>In order to successfully complete the registration process within the 20-minute time limit, you are required to <u>have your passport details on hand</u> for ease of reference.</p>

                <p><u>For those who are not departing from Singapore</u>, please ensure that you have a soft copy of your flight itinerary which you will be required to attach together with the registration form.</p>

                <p>Thank you.</p>
        </div>
        <footer class="cbTerms">
            <div class="checkbox">
                <label for="cbTerms" class="">
                <input type="checkbox" id="cbTerms" name="cbTerms" /> 
                I have read and fully understood the important notes above.</label>
            </div>
            <!-- <a href="/registration" class="btn btn-danger btnForward">Proceed with Registration</a> -->
        </footer>
    </div>
</template>
<script>
export default {
    name: 'Terms'
}
</script>

<style lang="less" scoped>
</style>